exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".section-password-removal {\n}\n@media (max-width: 992px) {\n  .section-password-removal {\n    padding: 0;\n  }\n}\n", ""]);

